// extracted by mini-css-extract-plugin
module.exports = {"root":"PreviewTable_root__NaNi6","paper":"PreviewTable_paper__2CP60","table":"PreviewTable_table__2jrEo"};